export const REDIRECTION_ERROR_STATUS_CODES = 300;
export const CLIENT_ERROR_STATUS_CODES = 400;
export const SERVER_ERROR_STATUS_CODES = 500;
